"use client";

import Recommendations from "@/app/ec/product/recommendations/recommendations";
import VendorProductsList from "@/app/vendor/[name]/[id]/vendorProductsList";
import VendorProductsListContainer from "@/app/vendor/[name]/[id]/vendorProductsListContainer";
import { ErrorBoundary } from "react-error-boundary";
import style from "./vendorDetails.module.scss";

export default function VendorDetailProductRecommendations({ vendorDetails }: VendorDetailProductRecommendationsProps) {
  const vendorName = vendorDetails.name;

  return (
    <aside id="vendor-recommendations">
      {vendorName && (
        <ErrorBoundary fallback={<></>}>
          <Recommendations
            modelParams={{
              queryParameters: {
                filters: `vendor:"${vendorName}" AND availability:Y`,
              },
            }}
            title={`${vendorName} Best Sellers`}
            model="trending-items"
            orderBy="priority"
            className={style.productRecommendations}
            titleClassName={style.sectionTitle}
          />
        </ErrorBoundary>
      )}
      <ErrorBoundary fallback={<></>}>
        <VendorProductsListContainer>
          <VendorProductsList vendorName={vendorDetails.name} />
        </VendorProductsListContainer>
      </ErrorBoundary>
    </aside>
  );
}

export type VendorDetailProductRecommendationsProps = {
  vendorDetails: VendorDetails;
};
